import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { map, Observable, take } from 'rxjs';
import { UserAccessService } from '../../user/access/user-access.service';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard {
  constructor(
    private accessService: UserAccessService,
    private router: Router
  ) {}

  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.isAdminCheck();
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.isAdminCheck();
  }

  private isAdminCheck(): Observable<boolean | UrlTree> {
    // Return observable so guard waits until isUserPlanUpdated AND isAuthorized
    // then it actually returns true/url
    return this.accessService.isUserPlanUpdated.pipe(
      filter((updated) => updated && this.accessService.getIsAuthorized()),
      take(1),
      map(() =>
        this.accessService.getIsAdmin()
          ? true
          : this.router.createUrlTree(['/sign-in'])
      )
    );
  }
}
